<template>
  <div>
    <el-dialog :visible="true" width="100%" :show-close="false" class="selectTime">
      <h3 class="text-center">{{listSche[0].teacher.teacherName}}<small style="margin-left:24px;">{{listSche[0].planDate}}</small></h3>
      <el-radio v-for="schedule,index in listSche" :key="index" style="margin:10px 10px;"
        v-model="selectIndex" :label="index">{{schedule.planStartTime}}-{{schedule.planEndTime}} {{schedule.room.name}}</el-radio>
      <span slot="footer">
        <el-button @click="cancel" round>取 消</el-button>
        <el-button type="primary" :disabled="selectIndex == -1"  @click="selectSchedule" round>确 定</el-button>
      </span>
    </el-dialog>  
  </div>
</template>

<script>
export default { 
  props: {
    listSche: Array,
  },   
  data() {
    return {
      selectIndex: -1,
    };
  },
  mounted() {   
  },  
  methods: {
    cancel(){
      this.$emit('cancel-selectSchedule');
    },
    selectSchedule(){
      this.$emit('select-schedule',this.listSche[this.selectIndex]);
    }
  }
};
</script>
<style scoped>
>>> .el-dialog {
  position: absolute;
  bottom: 0;
  margin: 0;
}
.selectTime h3 {
  margin-bottom: 10px;
}
.selectTime >>> .el-dialog__body {
  padding: 0;
  text-align: center;
}
</style>
